import { Conexion } from "../../../../../Config/Coneccion";

class CategoriaConecction extends Conexion {
    clase = 'Programa/Categoria';
}
var conOr: CategoriaConecction;
export function conCategoria() {
    if (conOr === undefined) conOr = new CategoriaConecction();
    return conOr;
}